import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardSearch from "./DashboardSearch.js";
import { fetchData } from "../../utils/api.js";
import searchIcon from "../../assets/brand/search.svg";

const GlobalSearch = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchSearchData = async () => {
    if (hasFetched || isLoading) return;
    setIsLoading(true);

    try {
      const [leagues, teams] = await Promise.all([
        fetchData("/leagues"),
        fetchData("/teams"),
      ]);

      let allItems = [];

      if (leagues) {
        allItems = [
          ...allItems,
          ...leagues.map((l) => ({
            ...l,
            id: `league-${l.league_id || l.id}`,
            searchType: "league",
          })),
        ];
      }

      if (teams) {
        allItems = [
          ...allItems,
          ...teams.map((t) => ({
            ...t,
            id: `team-${t.team_id || t.id}`,
            searchType: "team",
          })),
        ];
      }

      setItems(allItems);
      setHasFetched(true);
    } catch (err) {
      console.error("Error fetching global search data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFocus = () => {
    fetchSearchData();
  };

  const handleItemClick = (item) => {
    if (item.searchType === "league") {
      navigate(`/league/${item.league_id}`);
    } else if (item.searchType === "team") {
      navigate(`/team/${item.team_id}`);
    }
  };

  const getItemLabel = (item) => {
    return item.team_name || item.name || "";
  };

  const getItemSubLabel = (item) => {
    const city = item.city;
    const state = item.state;
    return city && state ? `${city}, ${state}` : "";
  };

  const getItemBadge = (item) => {
    const isLeague = item.searchType === "league";
    return (
      <span
        style={{
          fontSize: "0.7em",
          padding: "2px 8px",
          borderRadius: "12px",
          backgroundColor: isLeague
            ? "var(--color-primary-transparent, rgb(0 94 121 / 15%))"
            : "var(--color-ruby-transparent, rgb(224 17 95 / 15%))",
          color: isLeague ? "var(--color-primary)" : "var(--color-ruby)",

          fontWeight: "700",
          letterSpacing: "0.5px",
          marginLeft: "auto",
          display: "inline-block",
        }}
      >
        {isLeague ? "League" : "Team"}
      </span>
    );
  };

  return (
    <div
      className="global-search"
      style={{
        flex: 1,
        maxWidth: "400px",
        margin: "0 0 0 12px",
        position: "relative",
      }}
    >
      <img
        src={searchIcon}
        alt="Search"
        style={{
          position: "absolute",
          left: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          width: "16px",
          height: "16px",
          pointerEvents: "none",
          zIndex: 1,
          opacity: 0.5,
        }}
      />
      <DashboardSearch
        items={items}
        searchKeys={["name", "team_name", "city", "state"]}
        placeholder="Search leagues and teams..."
        onItemClick={handleItemClick}
        getItemLabel={getItemLabel}
        getItemSubLabel={getItemSubLabel}
        getItemBadge={getItemBadge}
        onFocus={handleFocus}
      />
    </div>
  );
};

export default GlobalSearch;
